import PriceList from "./PriceList"
import { PriceListStore } from "./priceListReducer"

function getStore(state): PriceListStore {
    return state.priceListReducer as PriceListStore
}

export function getPriceList(state, id): PriceList | undefined {
    return getStore(state).priceLists.get(id)
}



// WEBPACK FOOTER //
// ./src/state/price-list/priceListSelectors.ts